/*
 * Rebul slotbreker (21 okt 2026).
 * Gaat een klant vanaf de PAY.-betaalpagina terug zonder te betalen, dan blijft de Shopify-checkout
 * van die winkelwagen op "Je bestelling wordt verwerkt" staan en komt elke nieuwe poging daar weer uit.
 * Shopify's checkout (zelfde domein) bewaart in localStorage "__ui" per checkout-id een
 * "idempotency-token" zodra de klant op "Nu betalen" klikt. De checkout-id is het token van de
 * winkelwagen. Staat er zo'n betaalpoging voor de huidige winkelwagen, dan is er betaald zonder dat de
 * bestelling rond is (anders was de winkelwagen leeg). Bij afrekenen maken we dan een nieuwe winkelwagen
 * met dezelfde inhoud, zodat de klant een nieuwe checkout krijgt. Zonder betaalpoging doet dit niets.
 * Elke fout valt terug op het normale afrekenen.
 */
(function () {
  'use strict';

  var busy = false;

  function cartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split('?')[0] : '';
  }

  function paymentStarted(token) {
    var raw;
    try { raw = window.localStorage.getItem('__ui'); } catch (e) { return false; }
    if (!token || !raw || raw.indexOf(token) === -1) return false;
    try {
      return JSON.parse(raw).some(function (entry) {
        return entry && entry[0] && entry[0].id === token && entry[1] && entry[1]['idempotency-token'];
      });
    } catch (e) {
      return false;
    }
  }

  function postJson(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function rebuildCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return false;
        var items = cart.items.map(function (item) {
          var line = { id: item.variant_id, quantity: item.quantity };
          if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
          if (item.selling_plan_allocation) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
          return line;
        });
        var update = {};
        if (cart.note) update.note = cart.note;
        if (cart.attributes && Object.keys(cart.attributes).length) update.attributes = cart.attributes;
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        if (codes.length) update.discount = codes.join(',');

        var oldCookie = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
        document.cookie = 'cart=; Max-Age=0; path=/';
        return postJson('/cart/add.js?_easygift_apply_rules=false', { items: items })
          .catch(function (err) {
            if (oldCookie) document.cookie = 'cart=' + oldCookie[1] + '; Max-Age=1209600; path=/; SameSite=Lax';
            throw err;
          })
          .then(function () {
            if (!Object.keys(update).length) return true;
            return postJson('/cart/update.js?_easygift_apply_rules=false', update).then(function () { return true; }, function () { return true; });
          });
      });
  }

  function checkoutTarget(el) {
    if (!el || !el.closest) return null;
    var trigger = el.closest('a[href], button[name="checkout"], input[name="checkout"]');
    if (!trigger) return null;
    if (trigger.tagName === 'A') {
      var href = trigger.getAttribute('href') || '';
      return /\/checkout\/?(\?|#|$)/.test(href) ? { el: trigger, href: href } : null;
    }
    if (!trigger.form) return null;
    var action = trigger.form.getAttribute('action') || '/cart';
    return { el: trigger, href: action.replace(/cart\/?$/, 'checkout') };
  }

  function proceed(target, rebuilt) {
    var form = target.el.tagName === 'A' ? null : target.el.form;
    if (!form || rebuilt) {
      window.location.href = target.href;
      return;
    }
    if (form.requestSubmit) {
      form.requestSubmit(target.el);
      return;
    }
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'checkout';
    hidden.value = '1';
    form.appendChild(hidden);
    form.submit();
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var target = checkoutTarget(event.target);
    if (!target) return;
    if (busy) {
      event.preventDefault();
      return;
    }
    if (!paymentStarted(cartToken())) return;

    event.preventDefault();
    busy = true;
    target.el.setAttribute('aria-busy', 'true');
    target.el.style.opacity = '0.6';
    rebuildCart()
      .catch(function () { return false; })
      .then(function (rebuilt) {
        busy = false;
        target.el.removeAttribute('aria-busy');
        target.el.style.opacity = '';
        proceed(target, rebuilt);
      });
  });
})();
